<div class="sidenav-container flex">
  <div class="sidenav-sidebar" [ngClass]="isExpanded? '!w-[258px]': '!w-[60px]'">
    
    <div class="flex flex-row h-full">
      <div class="flex flex-col h-full bg-white"
        [ngClass]="isExpanded? 'w-[250px]': ''">
        <!-- side nav header -->
        <div class="h-[4.625rem] ml-[1rem] pt-[1.25rem]">
          <div class="details content-center flex flex-row">

            <div class="w-[2.125rem]">
              <img src={{icon}} alt="Logo" class="logo h-[24px]">
            </div>

            <div class="basis-3/5 font-medium flex flex-col justify-center overflow-hidden" *ngIf="isExpanded">
              <div
                *ngIf="pageTitle"
                class="text-base overflow-hidden text-ellipsis whitespace-nowrap">
                {{pageTitle}}
              </div>
            </div>

          </div>
        </div>
        <!-- side nav header -->

        <!-- side nav body -->
        <div class="sidenav_body grow">
          <app-navigation [isExpanded]="isExpanded"/>
        </div>
        <!-- side nav body -->

        <div class="spacer"></div>

        <!-- side nav footer -->
        <div class="sidenav_footer flex flex-col justify-center items-center mb-6" *ngIf="isExpanded">
          <img src={{this.logo}} alt="Logo" class="logo h-[5rem]">
          <div
            *ngIf="tenantId && rolesService.hasRole('framework_tenants_switch')"
            class="text-[#848488] text-sm font-light leading-3 absolute bottom-[6px]" >{{tenantId}} (v. {{versionNumber}})</div>
        </div>
        
        <!-- side nav footer -->
      </div>
      <div class="w-[12px] bg-[#F9F9F9] border-l border-gray justify-center items-center flex">
        <div class="expandHandle bg-[#d4d4d4] hover:bg-[#b7b5b5] m-1 h-[22px] w-[4px] rounded-md cursor-pointer"
          (click)="isExpanded = !isExpanded"
          [tooltipOptions]="tooltipOptions"
          [pTooltip]="isExpanded ? ('layoutComponent.tooltips.collapseMenu' | translate) : ('layoutComponent.tooltips.expandMenu' | translate)"></div>
      </div>
    </div>
  </div>
  <div class="sidenav-content">
    <!-- toolbar -->
      <div class="sticky top-0 mx-auto px-[1.5rem] h-[5.125rem] bg-[#F9F9F9] z-50 flex max-w-7xl">

        <div class="flex-grow flex flex-row justify-start pt-[1.125rem] flex-wrap">
          <ng-container *ngIf="this.licenseService?.isLicenceUser()">
            <app-orders-search/>
          </ng-container>
        </div>

        <div class="grow flex flex-row justify-end pt-[0.875rem] flex-wrap">
          <!-- #741: Oberflächen-Umschalter, links vor Hilfe/Glocke/Einstellungen.
               Trägt bewusst eine ausgeschriebene Beschriftung statt nur eines Icons —
               das Label ist das, was den Knopf auffindbar macht, und sein Wechsel ist
               der Beleg, dass das Umschalten gegriffen hat. Rendert nur, wenn das
               Deployment dafür konfiguriert ist. -->
          <app-ui-channel-switch class="pr-2 pt-1" />
          <nx-default-button
            [menuItems]="helpMeuItems"
            [tooltip]="'layoutComponent.tooltips.help' | translate"
            class="pr-2 pt-1"
            [icon]="'icon-support-center'">
          </nx-default-button>
          <!-- Gescrollt wird INNERHALB der Komponente, nicht hier: seit dem Infinite Scroll
               (Nacharbeit 19.08.2026) braucht deren IntersectionObserver den Scroll-Container als
               `root`, und Kopf und Filterzeile sollen stehenbleiben. Das Panel gibt nur noch die
               Breite vor. -->
          <p-overlayPanel
            #op
            [style]="{width: '480px'}"
            (onShow)="notificationPopoverRender = true"
            (onHide)="notificationPopoverRender = false">
            <!-- Klicks INNERHALB eines p-overlayPanel loesen seinen Dismiss-Listener nicht aus.
                 Das Popover muss deshalb ausdruecklich zugemacht werden, sobald aus ihm heraus
                 navigiert wurde — sonst liegt es ueber dem neuen Screen. -->
            <app-notification-center
              *ngIf="notificationPopoverRender"
              (navigated)="op.hide()">
            </app-notification-center>
          </p-overlayPanel>
          <nx-default-button
            (click)="op.toggle($event)"
            [badgeValue]="unreadNotificationsCount()"
            [tooltip]="'layoutComponent.tooltips.notifications' | translate"
            class="pr-2 pt-1 h-[36px] notifications"
            [icon]="'icon-notification'">
          </nx-default-button>
          <nx-default-button
            [menuItems]="mainMenuItems"
            [menuWithIcon]="true"
            [tooltip]="'layoutComponent.tooltips.settings' | translate"
            class="pt-1"
            [icon]="'icon-settings'">
            <ng-template nxTemplate="menuEndTemplate">
              <div class="pl-3 py-1 text-[#848488] font-light leading-3">
                {{givenName}} {{familyName}}
              </div>
            </ng-template>
        </nx-default-button>
        </div>

      </div>
    <!-- toolbar -->
    
    <!-- Split-View Container (global) -->
    <div class="flex flex-row overflow-hidden h-[calc(100%-96px)]">
      
      <!-- Main Content Area (shrinks to 50% when split-view is active) -->
      <div class="h-full transition-all duration-150 overflow-y-auto"
           [style.opacity]="isloading ? '0.5' : '1'"
           [ngClass]="{
             'w-1/2': sidebarService.showSplitView(),
             'w-full': !sidebarService.showSplitView()
           }">
        <div class="h-full mx-auto px-6 w-full"
             [style.maxWidth]="expandService?.isExpanded() ? '100%' : '80rem'">
          <div class="h-full pb-[22px]">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <!-- Right Panel: Split-View Detail (global portal host) -->
      <div class="h-full transition-all duration-150 split-view"
           [ngClass]="{
             'w-1/2': sidebarService.showSplitView(),
             'w-0 overflow-hidden': !sidebarService.showSplitView()
           }">
        <div class="h-full border-l bg-white overflow-y-auto">
          <lib-sidebar-portal-host />
        </div>
      </div>

    </div>

  </div>
</div>
